import ListErrorWarnings from '@molecules/ListErrorWarnings'

export default {
  components: {
    ListErrorWarnings
  },
  methods: {
    listErrorFilter(listErrorField, message) {
      if (this.listErrors[listErrorField] && this.listErrors[listErrorField].hasError) {
        return 'Invalid'
      }

      return message
    }
  },
  computed: {
    listErrorWarnings () {
      let warnings = []
      Object.keys(this.listErrors).forEach((formId) => {
        let vuelidate = null;
        if(this.$v) {
          vuelidate = this.$v;
        }
        if(this.v$) {
          vuelidate = this.v$;
        }
        const validation = vuelidate[formId]
        if (!validation) {
          return
        }

        this.listErrors[formId].hasError = false

        const field = this.listErrors[formId]
        const fieldErrorKeys = Object.keys(field.errors)
        for (let i = 0; i < fieldErrorKeys.length; ++i) {
          const fieldErrorKey = fieldErrorKeys[i]
          const error = field.errors[fieldErrorKey]
          if (!vuelidate[formId][fieldErrorKey]) {
            warnings.push({
              formId: error.formId || formId,
              text: error.error || (field.prefix + ' ' + this[`${formId}Error`])
            })

            this.listErrors[formId].hasError = true

            break
          }
        }
      })

      return warnings
    }
  }
}
